import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { TramiteSupersociedadesRoiDto } from '../../../../dto/tramites/tramite-roi.dto';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { FormGroup, Validators } from '@angular/forms';
import { Constants, FILTRO_TIPO_DOCUMENTO_INSOLVENCIA } from '../../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { FormField, FormFieldOption } from '../../../../dto/util/form-field';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento.dto';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { Router } from '@angular/router';
import { ListasService } from '../../../../services/listas.service';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { ListaValorRequestDto, ListaValorResponseDto } from '../../../../dto/tramites/lista_valor.dto';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { TramiteSupersociedadesRoiService } from '../../../../services/tramite-supersociedades-roi.service';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { TableColumn } from "../../../../dto/util/table-column";
import {
  DatosProfesionalesDTO,
  ItemTablaDTO, ProfesionalDTO, RespuestaEliminarDTO, TablaProfesionalesDTO
} from "../../supersociedades/liquidacion-judicial/models/liquidacion-judicial-DTO";
import { TableAction } from "../../../../dto/util/table-action";
import { TramiteResponseDTO } from "../../../../dto/tramites/tramite.dto";
import { TramiteService } from '../../../../services/tramite.service';
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { FormComponent } from '../../../util/form/form.component';
declare function nextItemAdvanceLineIHorizonal(event: any): void;

@Component({
  selector: 'app-roi-sucursales',
  templateUrl: './roi-sucursales.component.html',
  styleUrl: './roi-sucursales.component.scss'
})
export class RoiSucursalesComponent implements OnInit, OnChanges {
  @Input() tramiteRoi?: TramiteSupersociedadesRoiDto;
  @Input() nombreTipoSolicitante?: string = '';
  @Input() idTipoSolicitante?: number | undefined;
  @Input() paises: PaisDto[] = [];
  @Input() listaTiposDocumento: TipoDocumentoDto[] = [];
  @Output() formSucursalOutput = new EventEmitter<TramiteSupersociedadesRoiDto>();

  // Formularios
  reorSucursalIdentificacionDeudor: FormField[] = [];
  reorSucursalInformacionProfesionales: FormField[] = [];
  reorSucursalSupuestosAdmisibilidad: FormField[] = [];
  reorSucursalRelacionPasivos: FormField[] = [];
  reorSucursalInformacionFinancieraMes: FormField[] = [];
  reorSucursalInformacionFinancieraAnio: FormField[] = [];
  reorSucursalEstadosFinancieros: FormField[] = [];
  reorSucursalOtrosDocumentos: FormField[] = [];
  reorSucursalReporteBienesMobiliarios: FormField[] = [];
  reorSucursalDocumentosAdicionales: FormField[] = [];

  campoTipoRevisor: FormField[] = [];
  formTipoRevisor!: FormGroup | undefined;
  camposRevisorPN: FormField[] = [];
  formRevisorPN!: FormGroup | undefined;
  camposRevisorPJ: FormField[] = [];
  formRevisorPJ!: FormGroup | undefined;
  campoTipoApoderado: FormField[] = [];
  formTipoApoderado!: FormGroup | undefined;
  camposApoderadoPN: FormField[] = [];
  formApoderadoPN!: FormGroup | undefined;
  camposApoderadoPJ: FormField[] = [];
  formApoderadoPJ!: FormGroup | undefined;
  campoTipoContador: FormField[] = [];
  formTipoContador!: FormGroup | undefined;
  camposContadorPN: FormField[] = [];
  formContadorPN!: FormGroup | undefined;
  camposContadorPJ: FormField[] = [];
  formContadorPJ!: FormGroup | undefined;
  campoTipoRepresentante: FormField[] = [];
  formTipoRepresentante!: FormGroup | undefined;
  camposRepresentantePN: FormField[] = [];
  formRepresentantePN!: FormGroup | undefined;
  camposRepresentantePJ: FormField[] = [];
  formRepresentantePJ!: FormGroup | undefined;

  formIdentificacionDeudor!: FormGroup;
  formInformacionProfesionales!: FormGroup;
  formSupuestosAdmisibilidad!: FormGroup;
  formRelacionPasivos!: FormGroup;
  formInformacionFinancieraMes!: FormGroup;
  formInformacionFinancieraAnio!: FormGroup;
  formEstadosFinancieros!: FormGroup;
  formOtrosDocumentos!: FormGroup;
  formReporteBienesMobiliarios!: FormGroup;
  formDocumentosAdicionales!: FormGroup;

  // Tramite
  tipoTramite: number = Constants.ID_ENTIDAD_SSO_ROI;
  idTramite!: number | null;
  entidadId = Constants.ID_ENTIDAD_SUPER_SOCIEDADES;
  idTramiteSsoRoi!: number;

  // Archivos
  mostrarArchivos: boolean = true;
  enviarDocumentos = false;
  archivosCargados: ArchivoItemDto[] = [];

  enviarEntidad: boolean = false;

  // Multilenguaje
  roiText: any = {};
  comunText: any = {};
  alertaText: any = {};

  dataUsuario!: PersonaLoginDTO;
  idUsuario: number | undefined;

  auxIdCountry: number[] = [];
  grupoPreparadores: { Id: number, Nombre: string }[] = [];

  currentYear: number = 0;
  lastYear: number = 0;
  yearBeforeLast: number = 0;
  twoYearsAgo: number = 0;

  listaSolicitante: ListaValorResponseDto[] = [];
  listaCertificoActividad: ListaValorResponseDto[] = [];
  listaPasosRoi = Constants.PASOS_ROI;

  // Archivos
  mostrarArchivosPaso2: boolean = false;
  mostrarArchivosPaso3: boolean = false;
  mostrarArchivosPaso4: boolean = false;
  mostrarArchivosPaso5: boolean = false;
  mostrarArchivosPaso6: boolean = false;
  mostrarArchivosPaso7: boolean = false;
  mostrarArchivosPaso8: boolean = true;
  mostrarArchivosPaso9: boolean = false;
  mostrarArchivosPaso10: boolean = false;

  archivosCargadosPasoUno: ArchivoItemDto[] = [];
  archivosCargadosPasoDos: ArchivoItemDto[] = [];
  archivosCargadosPasoTres: ArchivoItemDto[] = [];
  archivosCargadosPasoCuatro: ArchivoItemDto[] = [];
  archivosCargadosPasoCinco: ArchivoItemDto[] = [];
  archivosCargadosPasoSeis: ArchivoItemDto[] = [];
  archivosCargadosPasoSiete: ArchivoItemDto[] = [];
  archivosCargadosPasoOcho: ArchivoItemDto[] = [];
  archivosCargadosPasoNueve: ArchivoItemDto[] = [];
  archivosCargadosPasoDiez: ArchivoItemDto[] = [];
  archivosCargadosPasoOnce: ArchivoItemDto[] = [];
  archivosCargadosPasoDoce: ArchivoItemDto[] = [];
  archivosCargadosPasoTrece: ArchivoItemDto[] = [];
  archivosCargadosPasoCatorce: ArchivoItemDto[] = [];

  // pretenciones
  pretencionesPaso1: string = 'sociedadSucursal';
  pretencionesPaso2: string = '';
  pretencionesPaso3: string = '';
  pretencionesPaso4: string = '';
  pretencionesPaso7: string = '';
  pretencionesPaso8: string = '';
  pretencionesPaso10: string = '';

  // Listas de ids documentos requeridos por pasos
  idsFilesPasoUno: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoDos: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoTres: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoCuatro: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoCinco: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoSeis: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoSiete: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoOcho: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoNueve: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoDiez: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoOnce: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoDoce: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoTrece: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoCatorce: TipoAnexoTipoTramiteDto[] = [];

  // Boolean
  mostrarTipoRevisor = false;
  mostrarTipoApoderado = false;
  mostrarTipoContador = false;
  mostrarRevisorPN = false;
  mostrarRevisorPJ = false;
  mostrarApoderadoPN = false;
  mostrarApoderadoPJ = false;
  mostrarContadorPN = false;
  mostrarContadorPJ = false;
  mostrarTipoRepresentante = false;
  mostrarRepresentantePN = false;
  mostrarRepresentantePJ = false;

  //Tablas
  columnasRevisor: TableColumn[] = [];
  columnasApoderado: TableColumn[] = [];
  columnasContador: TableColumn[] = [];
  accionesRevisor: TableAction[] = [];
  accionesApoderado: TableAction[] = [];
  accionesContador: TableAction[] = [];
  datosRevisores: DatosProfesionalesDTO[] = [];
  datosApoderados: DatosProfesionalesDTO[] = [];
  datosContadores: DatosProfesionalesDTO[] = [];
  datosRepresentantes: DatosProfesionalesDTO[] = [];
  columnasRepresentante: TableColumn[] = [];
  accionesRepresentante: TableAction[] = [];

  // String
  nombreTramite = '';
  entidad = '';
  // Listas de tipo ListaValorRequestDto
  listaTipoSolicitantes: ListaValorRequestDto[] = [];
  listaMacrosector: ListaValorRequestDto[] = [];
  listaCodigosCIIU: ListaValorRequestDto[] = [];
  listaNaturaleza: ListaValorRequestDto[] = [];
  listaCertificoActividades: ListaValorRequestDto[] = [];
  listaCodigoGrupoPreparadores: ListaValorRequestDto[] = [];

  solicitante: string = 'sociedad';

  @ViewChildren('FormComponent') personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
    private readonly router: Router,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly serviceRoi: TramiteSupersociedadesRoiService,
    private readonly tramiteService: TramiteService,
    private readonly _cuentaService: ConfigurarCuentasService
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
  }

  ngOnInit(): void {
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    this.idUsuario = this.dataUsuario?.idUsuario;
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
    ]).subscribe(([tramitesText, comunLabelText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.roiText[key] = tramitesText[key];
      }

      this.tramiteService.obtenerNombreEntidadPorId(1).subscribe({
        next: (data) => {
          this.entidad = data.entidad;
        },
        error: (err) => console.error('Error al obtener entidad', err),
      });

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
      this.currentYear = new Date().getFullYear();
      this.lastYear = this.currentYear - 1;
      this.yearBeforeLast = this.currentYear - 2;
      this.twoYearsAgo = this.currentYear - 3;
      this.initSucursal();
    });
    this.getListas();
    // Revisor fiscal
    this.initFormTipoRevisor();
    this.initFormRevisorPN();
    this.initFormRevisorPJ();
    this.listaSimpleRevisores();
    // Apoderado
    this.initFormTipoApoderado();
    this.initFormApoderadoPN();
    this.initFormApoderadoPJ();
    this.listaSimpleApoderados();
    // Contador
    this.initFormTipoContador();
    this.initFormContadorPN();
    this.initFormContadorPJ();
    this.listaSimpleContadores();
    // Representante legal
    this.initFormTipoRepresentante();
    this.initFormRepresentantePN();
    this.initFormRepresentantePJ();
    this.listaSimpleRepresentantes();
    // Tablas
    this.initColumnsRevisor();
    this.initColumnsApoderado();
    this.initColumnsContador();
    this.initColumnsRepresentante();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSupersociedadesRoiDto =
      changes['tramiteRoi'].currentValue;

    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      this.idTramite = tramite.id!;
      setTimeout(() => {
        this.getListas();
        this.listaSimpleRevisores();
        this.listaSimpleApoderados();
        this.listaSimpleContadores();
        this.listaSimpleRepresentantes();
        this.listarRevisores();
        this.listarApoderados();
        this.listarContadores();
        this.listarRepresentantes();
        this.reorSucursalIdentificacionDeudor = this.reorSucursalIdentificacionDeudor.map(field => {
          switch (field.name) {
            case 'tipoDeDocumento':
              field.value = tramite.tipoIdentificacion.id;
              break;
            case 'numberOfDocument':
              field.value = tramite.numeroIdentificacion;
              break;
            case 'nombre':
              field.value = tramite.nombreRazonSocial;
              break;
            case 'codigoCIIU':
              field.value = tramite.codigoCIIU?.otroValor;
              break;
            case 'macrosector':
              field.value = tramite.macrosector?.id;
              break;
            case 'country':
              field.value = tramite.paisDomicilio.id;
              break;
            case 'departament':
              field.value = tramite.departamentoDomicilio.id;
              break;
            case 'municipality':
              field.value = tramite.municipioDomicilio.id;
              break;
            case 'otroDepartamento':
              field.value = tramite.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipio':
              field.value = tramite.ciudadExtranjero ?? '';
              break;
            case 'addressNotificacion':
              field.value = tramite.direccionNotificacion;
              break;
            case 'email':
              field.value = tramite.correoElectronicoNotificacion;
              break;
            case 'telefono':
              field.value = tramite.telefono;
              break;
            case 'naturaleza':
              field.value = tramite.naturaleza?.codigo;
              break;
            case 'participacionEstatal':
              field.value = tramite.porcentajeParticipacionEstatal;
              break;
            case 'numeroEmpleadasMujeres':
              field.value = tramite.numeroEmpleadosMujeres;
              break;
            case 'numeroEmpleadosHombres':
              field.value = tramite.numeroEmpleadosHombres;
              break;
            case 'representanteLegal':
              field.value = tramite.representanteLegal?.id;
              break;
          }
          return field;
        })
      }, 500);
      setTimeout(() => {
        this.reorSucursalInformacionProfesionales = this.reorSucursalInformacionProfesionales.map(field => {
          switch (field.name) {
            case 'contador':
              field.value = tramite.contador.id;
              break;
            case 'revisorFiscal':
              field.value = tramite.revisorFiscal?.id;
              break;
            case 'apoderado':
              field.value = tramite.idApoderado! ?? undefined;
              break;
            case 'representanteLegal':
              field.value = tramite.representanteLegal?.id;
              break;
          }
          return field;
        })
        // Mostrar archivos paso 2
        if (this.formInformacionProfesionales.get('apoderado')?.value) {
          this.pretencionesPaso2 = this.formInformacionProfesionales.get('apoderado')?.value;
          setTimeout(() => {
            this.mostrarArchivosPaso2 = true;
          }, 100);
        }
        this.reorSucursalSupuestosAdmisibilidad = this.reorSucursalSupuestosAdmisibilidad.map(field => {
          switch (field.name) {
            case 'certificoActividad':
              field.value = tramite.certificoActividad?.codigo;
              break;
          }
          return field;
        })
        if (this.formSupuestosAdmisibilidad.get('certificoActividad')?.value) {
          const pretencion = this.formSupuestosAdmisibilidad.get('certificoActividad')?.value;
          this.pretencionesPaso3 = this.getTagFileAdmisibilidad(pretencion);
          setTimeout(() => {
            this.mostrarArchivosPaso3 = true;
          }, 100);
        }
        this.reorSucursalRelacionPasivos = this.reorSucursalRelacionPasivos.map(field => {
          switch (field.name) {
            case 'tienePasivosRetenciones':
              field.value = tramite.tienePasivosRetenciones != undefined ? this.getValorRadioButton(tramite.tienePasivosRetenciones) : undefined;
              break;
            case 'tienePasivosDescuentos':
              field.value = tramite.tienePasivosDescuentos != undefined ? this.getValorRadioButton(tramite.tienePasivosDescuentos) : undefined;
              break;
            case 'tienePasivosAportes':
              field.value = tramite.tienePasivosAportes != undefined ? this.getValorRadioButton(tramite.tienePasivosAportes) : undefined;
              break;
          }
          return field;
        })
        if (this.formRelacionPasivos.valid) {
          this.mostrarArchivosPaso4 = false;
          this.pretencionesPaso4 = this.getTagFileRelacionPasivos(this.formRelacionPasivos);
          setTimeout(() => {
            this.mostrarArchivosPaso4 = true;
          }, 100);
        }
        this.reorSucursalInformacionFinancieraMes = this.reorSucursalInformacionFinancieraMes.map(field => {
          switch (field.name) {
            case 'fechaEstadoFinancieroMesAnterior':
              field.value = tramite.fechaEstadoFinancieroMesAnterior;
              break;
            case 'valorTotalActivosMesAnterior':
              field.value = tramite.valorTotalActivosMesAnterior;
              break;
            case 'valorTotalPasivosMesAnterior':
              field.value = tramite.valorTotalPasivosMesAnterior;
              break;
            case 'valorTotalPatrimonioMesAnterior':
              field.value = tramite.valorTotalPatrimonioMesAnterior;
              break;
            case 'codigoGrupoPreparadores':
              field.value = tramite.codigoGrupoPreparadores?.id;
              break;
          }
          return field;
        })
        this.reorSucursalInformacionFinancieraAnio = this.reorSucursalInformacionFinancieraAnio.map(field => {
          switch (field.name) {
            case 'fechaEstadoFinancieroAnioAnterior':
              field.value = tramite.fechaEstadoFinancieroAnioAnterior;
              break;
            case 'valorTotalActivosAnioAnterior':
              field.value = tramite.valorTotalActivosAnioAnterior;
              break;
            case 'valorTotalPasivosAnioAnterior':
              field.value = tramite.valorTotalPasivosAnioAnterior;
              break;
            case 'valorTotalIngresosOrdinariosAnioAnterior':
              field.value = tramite.valorTotalIngresosOrdinariosAnioAnterior;
              break;
            case 'valorTotalOtrosIngresosAnioAnterior':
              field.value = tramite.valorTotalOtrosIngresosAnioAnterior;
              break;
            case 'tieneIversionesSubsidiarias':
              field.value = tramite.tieneInversiones != undefined ? this.getValorRadioButton(tramite.tieneInversiones) : undefined;
              break;
            case 'valorTotalGananciaMetodoParticipacion':
              field.value = tramite.valorTotalGananciaMetodoParticipacion;
              break;
            case 'valorTotalGananciaMetodoAlCosto':
              field.value = tramite.valorTotalGananciaMetodoAlCosto;
              break;
            case 'valorTotalGananciaMetodoValorRazonable':
              field.value = tramite.valorTotalGananciaMetodoValorRazonable;
              break;
          }
          return field;
        })
        this.reorSucursalEstadosFinancieros = this.reorSucursalEstadosFinancieros.map(field => {
          switch (field.name) {
            case 'informacionRemitida':
              field.value = tramite.tieneInformacionRemitida != undefined ? this.getValorRadioButton(tramite.tieneInformacionRemitida) : undefined;
              break;
            case 'radicado2023':
              field.value = tramite.radicado2023;
              break;
            case 'radicado2022':
              field.value = tramite.radicado2022;
              break;
            case 'radicado2021':
              field.value = tramite.radicado2021;
              break;
          }
          return field;
        })
        if (this.getValorRadioButton(tramite.tieneInformacionRemitida!) == 1) {
          this.mostrarArchivosPaso7 = false;
        } else {
          this.mostrarArchivosPaso7 = true;
        }
        this.reorSucursalOtrosDocumentos = this.reorSucursalOtrosDocumentos.map(field => {
          switch (field.name) {
            case 'causalDisolucion':
              field.value = tramite.tieneCausalDisolucion != undefined ? this.getValorRadioButton(tramite.tieneCausalDisolucion) : undefined;
              break;
            case 'pasivosPensionales':
              field.value = tramite.tienePasivosPensionales != undefined ? this.getValorRadioButton(tramite.tienePasivosPensionales) : undefined;
              break;
            case 'garanteTerceros':
              field.value = tramite.esGaranteTerceros != undefined ? this.getValorRadioButton(tramite.esGaranteTerceros) : undefined;
              break;
          }
          return field;
        })
        this.reorSucursalReporteBienesMobiliarios = this.reorSucursalReporteBienesMobiliarios.map(field => {
          switch (field.name) {
            case 'garantiaInmobiliaria':
              field.value = tramite.tieneBienesGarantiaInmobiliaria != undefined ? this.getValorRadioButton(tramite.tieneBienesGarantiaInmobiliaria) : undefined;
              break;
          }
          return field;
        })
        if (this.formReporteBienesMobiliarios.get('garantiaInmobiliaria')?.value == 1) {
          this.pretencionesPaso10 = this.getTagFileMobiliarios(this.formReporteBienesMobiliarios);
          setTimeout(() => {
            this.mostrarArchivosPaso10 = true;
          }, 100);
        }
        this.reorSucursalDocumentosAdicionales = this.reorSucursalDocumentosAdicionales.map(field => {
          switch (field.name) {
            case 'descripcion':
              field.value = tramite.descripcion;
              break;
          }
          return field;
        })
      }, 800);
    } else {
      this.getData();
    }
  }

  getValorRadioButton(valor: boolean) {
    if (valor) {
      return 1;
    } else {
      return 2;
    }
  }

  getListas() {
    // Tipo solicitante
    this.listaServices
      .listaValor(Constants.ROI_TIPO_SOLICITANTE)
      .subscribe(response => {
        this.listaSolicitante = response as ListaValorResponseDto[];
        const listaTipoSolicitantes = response as ListaValorResponseDto[];
        this.listaTipoSolicitantes = listaTipoSolicitantes.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
    // Macrosector
    this.listaServices
      .listaValor(Constants.MACROSECTOR)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.reorSucursalIdentificacionDeudor = this.reorSucursalIdentificacionDeudor.map(field => {
          if (field.name === 'macrosector') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          // Setear tipos Documento
          const tiposPermitidos = FILTRO_TIPO_DOCUMENTO_INSOLVENCIA.PERSONA_TIPO_NATURAL;

          this.listaTiposDocumento = this.listaTiposDocumento.filter(
            d => tiposPermitidos.includes(d.TipoDocumento ?? '')
          );
          if (field.name === 'tipoDeDocumento') {
            field.options = this.listaTiposDocumento.map(item => ({
              Id: item.Id!,
              Nombre: item.Nombre!,
            }));
          }
          return field;
        });
        const listaMacrosector = response as ListaValorResponseDto[];
        this.listaMacrosector = listaMacrosector.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
    // CIIUS
    this.listaServices
      .listaValor(Constants.CODIGO_CIIU)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.reorSucursalIdentificacionDeudor = this.reorSucursalIdentificacionDeudor.map(field => {
          if (field.name === 'codigoCIIU') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Otro_valor!,
              Nombre: `${item.Otro_valor!} - ${item.Valor!}`,
            }));
          }
          return field;
        });
        const listaCodigosCIIU = response as ListaValorResponseDto[];
        this.listaCodigosCIIU = listaCodigosCIIU.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
    // Naturaleza
    this.listaServices
      .listaValor(Constants.NATURALEZA)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.reorSucursalIdentificacionDeudor = this.reorSucursalIdentificacionDeudor.map(field => {
          if (field.name === 'naturaleza') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Codigo!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
        const listaNaturaleza = response as ListaValorResponseDto[];
        this.listaNaturaleza = listaNaturaleza.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
    // CESE_PAGOS
    this.listaServices
      .listaValor(Constants.CESE_PAGOS)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.listaCertificoActividad = data;
        this.reorSucursalSupuestosAdmisibilidad = this.reorSucursalSupuestosAdmisibilidad.map(field => {
          if (field.name === 'certificoActividad') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Codigo!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
        const listaCertificoActividades = response as ListaValorResponseDto[];
        this.listaCertificoActividades = listaCertificoActividades.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
    // PREPARADOR_INFORMACION
    this.listaServices
      .listaValor(Constants.PREPARADOR_INFORMACION)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.reorSucursalInformacionFinancieraMes = this.reorSucursalInformacionFinancieraMes.map(field => {
          if (field.name === 'codigoGrupoPreparadores') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
            this.grupoPreparadores = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
        const listaCodigoGrupoPreparadores = response as ListaValorResponseDto[];
        this.listaCodigoGrupoPreparadores = listaCodigoGrupoPreparadores.map(item => ({
          id: item.Id,
          nombreLista: item.Nombre_Lista,
          valor: item.Valor,
          otroValor: item.Otro_valor,
          estado: item.Estado,
          codigo: item.Codigo
        }));
      });
  }

  // Lista simple revisores fiscales
  listaSimpleRevisores() {
    this.serviceRoi.listaSimpleRevisores(Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: FormFieldOption[]) => {
        this.reorSucursalInformacionProfesionales = this.reorSucursalInformacionProfesionales.map(field => {
          if (field.name === 'revisorFiscal') {
            field.options = resp;
          }
          return field;
        });
      });
  }
  // Lista simple apoderados
  listaSimpleApoderados() {
    this.serviceRoi.listaSimpleApoderados(Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: FormFieldOption[]) => {
        this.reorSucursalInformacionProfesionales = this.reorSucursalInformacionProfesionales.map(field => {
          if (field.name === 'apoderado') {
            field.options = resp;
          }
          return field;
        });
      });
  }
  // Lista simple contadores
  listaSimpleContadores() {
    this.serviceRoi.listaSimpleContadores(Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: FormFieldOption[]) => {
        this.reorSucursalInformacionProfesionales = this.reorSucursalInformacionProfesionales.map(field => {
          if (field.name === 'contador') {
            field.options = resp;
          }
          return field;
        });
      });
  }
  // Lista simple representantes
  listaSimpleRepresentantes() {
    this.serviceRoi.listaSimpleRepresentantes(Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: FormFieldOption[]) => {
        this.reorSucursalInformacionProfesionales = this.reorSucursalInformacionProfesionales.map(field => {
          if (field.name === 'representanteLegal') {
            field.options = resp;
          }
          return field;
        });
      });
  }
  initSucursal() {
    this.reorSucursalIdentificacionDeudor = [
      // SECCION INICIAL
      {
        name: 'tipoSolicitud',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_solicitud'],
        type: 'text',
        required: false,
        visible: true,
        width: '6',
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
        disabled: true,
        value: 'Reorganización Ordinaria'
      },
      {
        name: 'normaAplicable',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['norma_aplicable'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
        disabled: true,
        value: 'Ley 1116 de 2006'
      },
      // SECCION Identificación del deudor (Artículo 2, Ley 1116 de 2006)
      {
        isSubtitle: true,
        subtitleText:
          this.roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][1],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoDeDocumento',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'nombre',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'codigoCIIU',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['ciiu'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'macrosector',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['macrosector'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingresa el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['escriba-municipio'],
      },
      {
        name: 'addressNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contacto_deudor'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'naturaleza',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['naturaleza'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'participacionEstatal',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['participacion_estatal'],
        type: 'decimal',
        required: false,
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['participacion_estatal'],
        width: '6',
        visible: false,
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL_PORCENTAJE),
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal_porcentaje'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal_porcentaje']
        },
        dependsOn: 'naturaleza',
        visibilityCondition: value => value == 'NT_MIXTA',
      },
      {
        name: 'numeroEmpleadasMujeres',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        type: 'number',
        required: true,
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        width: '6',
        visible: true,
        maxLength: '5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      {
        name: 'numeroEmpleadosHombres',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        type: 'number',
        required: true,
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        width: '6',
        visible: true,
        maxLength: '5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      // ARCHIVO
      // Certificado de Existencia y Representación Legal
      // ARCHIVO
      // Documento mediante el cuál el máximo órgano competente autoriza al representante legal,
    ];
    // SECCION Información de profesionales asociados al deudor
    this.reorSucursalInformacionProfesionales = [
      {
        name: 'contador',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'revisorFiscal',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'apoderado',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'representanteLegal',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVO
      /**
       * Poder al abogado para realizar la solicitud -> DEPENDE DE SI SELECCIONA APODERADO */
      // SECCION Memoria explicativa de las causas de insolvencia
      /* ARCHIVO
       * Memoria explicativa de las causas de insolvencia
       */
    ];
    // SECCION Supuestos de admisibilidad
    this.reorSucursalSupuestosAdmisibilidad = [
      {
        name: 'certificoActividad',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['certificado_desarrollo_actividad'] + ":",
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
      // ARCHIVOS
      /**
       * Certificación que acredite la cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
       * Anexo de la certificación de cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
       * Certificación que acredite la incapacidad de pago -> Depende de certificadoDesarrolloActividad opcion 2
       */
    ];
    // SECCION Relación de Pasivos (Artículo 32, Ley 1429 de 2010)
    this.reorSucursalRelacionPasivos = [
      {
        name: 'tienePasivosRetenciones',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_retenciones'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
      // Archivos
      /**
       * Certificación de tener o no pasivos por retenciones obligatorias con el fisco
       * Plan para la atención de pasivos por retenciones obligatorias con el fisco -> Depende de que seleccione si
       */
      {
        name: 'tienePasivosDescuentos',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_descuentos'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      /**
       * Certificación de tener o no tener pasivos por descuentos efectuados a trabajadores
       * Plan para la atención de pasivos por descuentos efectuados a trabajadores
       */
      {
        name: 'tienePasivosAportes',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_aportes'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      /**
       * Certificación de tener o no tener pasivos por aportes al sistema de seguridad social
       * Plan para la atención de pasivos al sistema de seguridad social
       */
    ];
    // SECCION Información financiera con corte al último día calendario del mes anterior
    this.reorSucursalInformacionFinancieraMes = [
      {
        name: 'fechaEstadoFinancieroMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_mes_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true,
      },
      {
        name: 'valorTotalActivosMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPasivosMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPatrimonioMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['patrimonio_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'codigoGrupoPreparadores',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['grupo_preparadores_informacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
    ];
    // SECCION Información financiera con corte al último año anterior
    this.reorSucursalInformacionFinancieraAnio = [
      {
        name: 'fechaEstadoFinancieroAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_anio_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true,
      },
      {
        name: 'valorTotalActivosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPasivosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalIngresosOrdinariosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalOtrosIngresosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['otros_ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'tieneIversionesSubsidiarias',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_iversiones_subsidiarias'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'valorTotalGananciaMetodoParticipacion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_participacion'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoAlCosto',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_costo'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoValorRazonable',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_razonable'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
    ];
    // Sección Conjunto completo de estados financieros comparativos
    this.reorSucursalEstadosFinancieros = [
      {
        name: 'informacionRemitida',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['informacion_remitida'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      //ARCHIVOS
      /**
       * SELECCIONA NO
       * Estados financieros del último año (2023)
       * Notas y certificación a los estados financieros del último año (2023)
       * Dictamen del revisor fiscal del último año (2023)(si aplica)
       * Estados financieros del penúltimo año (2022)
       * Notas y certificación a los estados financieros del penúltimo año (2022)
       * Dictamen del revisor fiscal del penúltimo año (2022) (si aplica)
       * Estados financieros del antepenúltimo año (2021)
       * Notas a estados financieros del antepenúltimo año (2021)
       * Dictamen del revisor fiscal del antepenúltimo año (2021) (si aplica)
       */
      // Selecciona SI
      {
        name: 'radicado2023',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['radicado_2023'] + this.lastYear.toString(),
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(10),
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        visible: false,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['letras_numeros'],
          minlength: this.comunText['min-2'],
          maxlength: this.comunText['max-10'],
          pattern: this.comunText['solo-numeros']
        },
        dependsOn: 'informacionRemitida',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'radicado2022',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['radicado_2022'] + this.yearBeforeLast.toString(),
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(10),
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        visible: false,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['letras_numeros'],
          minlength: this.comunText['min-2'],
          maxlength: this.comunText['max-10'],
          pattern: this.comunText['solo-numeros']
        },
        dependsOn: 'informacionRemitida',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'radicado2021',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['radicado_2021'] + this.twoYearsAgo.toString(),
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(10),
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        visible: false,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['letras_numeros'],
          minlength: this.comunText['min-2'],
          maxlength: this.comunText['max-10'],
          pattern: this.comunText['solo-numeros']
        },
        dependsOn: 'informacionRemitida',
        visibilityCondition: value => value == 1,
      },
    ];
    // SECCION Otros documentos requeridos
    this.reorSucursalOtrosDocumentos = [
      // ARCHIVOS
      /**
       * Certificación de llevar contabilidad regular
       * Documento de la composición accionaria
       */
      {
        name: 'causalDisolucion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['causal_disolucion'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // Archivos
      // Selecciona si
      // Certificación de no encontrarse en causal de disolución
      // Selecciona no
      // Certificación causal de disolución
      {
        name: 'pasivosPensionales',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_pensionales'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      // SELECCIONA SI
      /**
       * Certificación del monto de las obligaciones causadas por cálculo actuarial
       * Documento que acredita el cálculo actuarial
       * Aprobación del cálculo actuarial
       * Certificación de encontrarse al día en mesadas pensionales, bonos y títulos pensionales
       */
      {
        name: 'garanteTerceros',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['garante_terceros'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // Archivos
      /**
       * Certificación en la que se relacione los terceros a los cuales el deudor es (avalista, garante o codeudor de terceros)
       *
       */
    ];
    /**
     * SECCION Reporte de bienes sujetos a garantías mobiliarias
     */
    this.reorSucursalReporteBienesMobiliarios = [
      {
        name: 'garantiaInmobiliaria',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['garante_inmobiliaria'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
    ];
    /**
     * SECCION Documentos Adicionales
     * Archivo
    */
    this.reorSucursalDocumentosAdicionales = [
      // ARCHIVO
      {
        name: 'descripcion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['descripcion'],
        type: 'text',
        required: false,
        width: '6',
        noConvertToUpperCase: true,
        validation: [
          Validators.pattern(Constants.REGEX_ACTA_PROTESTA),
        ],
        errorMessages: {
          pattern: this.comunText['campo-descripcion'],
        },
      },
    ];
  }

  initFormTipoRevisor() {
    this.campoTipoRevisor = [
      {
        name: 'tipoPersonaRevisor',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor_required'] }
      },
    ];
  }

  initFormRevisorPN() {
    this.camposRevisorPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormRevisorPJ() {
    this.camposRevisorPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initColumnsRevisor() {
    this.columnasRevisor = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'numeroDocumento',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesRevisor = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  initColumnsApoderado() {
    this.columnasApoderado = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesApoderado = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  initColumnsContador() {
    this.columnasContador = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesContador = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  initColumnsRepresentante() {
    this.columnasRepresentante = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesRepresentante = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  // Apoderado
  initFormTipoApoderado() {
    this.campoTipoApoderado = [
      {
        name: 'tipoPersonaApoderado',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado_required'] }
      },
    ];
  }

  initFormApoderadoPN() {
    this.camposApoderadoPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormApoderadoPJ() {
    this.camposApoderadoPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  // Contador
  initFormTipoContador() {
    this.campoTipoContador = [
      {
        name: 'tipoPersonaContador',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador_required'] }
      },
    ];
  }

  initFormContadorPN() {
    this.camposContadorPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormContadorPJ() {
    this.camposContadorPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  // Representante legal
  initFormTipoRepresentante() {
    this.campoTipoRepresentante = [
      {
        name: 'tipoPersonaRepresentante',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_representante'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_representante_required'] }
      },
    ];
  }

  initFormRepresentantePN() {
    this.camposRepresentantePN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormRepresentantePJ() {
    this.camposRepresentantePJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  // <!-- Sección inicial -->
  onSubmitSucursalIdentificacionDeudor(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formIdentificacionDeudor = event.form;
    const formGroup = event.form;
    const idTipoDocumento: number = +formGroup?.get('tipoDeDocumento')?.value;
    const identificacion: string = formGroup?.get('numberOfDocument')?.value;
    const numeroDocumento = this.reorSucursalIdentificacionDeudor.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      event.controlName == 'tipoDeDocumento' ||
      event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2
        ) {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['nit-maxlength'];
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if (event.controlName == 'country' || (event.form != undefined && event.form.get('country')?.value)) {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamento']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.removeValidators(
          Validators.required
        );
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
      } else {
        let clearInputs: boolean = false
        if (formGroup?.controls['country'].value) {
          this.auxIdCountry.push(formGroup?.controls['country'].value)
          if (this.auxIdCountry.length > 1) {
            clearInputs = formGroup?.controls['country'].value != this.auxIdCountry[this.auxIdCountry.length - 2]
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamento'].setValue('')
          formGroup?.controls['otroMunicipio'].setValue('')
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamento']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.markAsDirty();
        formGroup?.controls['otroMunicipio']?.markAllAsTouched();
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
        this.reorSucursalIdentificacionDeudor.forEach((field: FormField) => {
          if (['otroMunicipio', 'otroDepartamento']
            .includes(field.name)
          ) {
            field.required = true
          }
        });
      }
    }
    const participacionEstatal = this.reorSucursalIdentificacionDeudor.find(
      field => field.name == 'participacionEstatal'
    );
    if (event.controlName == 'naturaleza') {
      const valor = this.formIdentificacionDeudor.get('naturaleza')?.value;
      if (valor == 'NT_MIXTA') {
        this.setearObligatorio('participacionEstatal',
          this.reorSucursalIdentificacionDeudor,
          true)
        if (participacionEstatal != undefined) {
          formGroup
            .get('participacionEstatal')
            ?.setValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_DECIMAL_PORCENTAJE),
            ]);
          participacionEstatal.errorMessages!['pattern'] =
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal_porcentaje'];
        }
        formGroup.get('participacionEstatal')?.updateValueAndValidity();
      } else {
        this.setearObligatorio('participacionEstatal',
          this.reorSucursalIdentificacionDeudor,
          false)
        formGroup
          .get('participacionEstatal')
          ?.clearValidators();
        formGroup.get('participacionEstatal')?.updateValueAndValidity();
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
    this.mostrarCamposRequeridos(formGroup)
  }

  // <!-- Sección Información de profesionales asociados al deudor -->
  onSubmitSucursalInformacionProfesionales(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formInformacionProfesionales = event.form;
    if (this.formInformacionProfesionales?.get('apoderado')?.value) {
      this.pretencionesPaso2 = 'idApoderado';
      setTimeout(() => {
        this.mostrarArchivosPaso2 = true;
      }, 100);
    } else {
      this.mostrarArchivosPaso2 = false;
      this.idsFilesPasoDos = [];
    }
  }

  // <!-- Sección Supuestos de admisibilidad-->
  onSubmitSucursalSupuestosAdmisibilidad(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formSupuestosAdmisibilidad = event.form;
    if (this.formSupuestosAdmisibilidad?.get('certificoActividad')?.value) {
      const pretencion = this.formSupuestosAdmisibilidad.get('certificoActividad')?.value;
      this.pretencionesPaso3 = this.getTagFileAdmisibilidad(pretencion);
      setTimeout(() => {
        if (this.mostrarArchivosPaso3) {
          this.mostrarArchivosPaso3 = false;
          setTimeout(() => {
            this.mostrarArchivosPaso3 = true;
          }, 100);
        } else {
          this.mostrarArchivosPaso3 = true;
        }
      }, 200);
    } else {
      this.mostrarArchivosPaso3 = false;
    }
  }

  // <!-- Sección Relación de Pasivos (Artículo 32, Ley 1429 de 2010)-->
  onSubmitSucursalRelacionPasivos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formRelacionPasivos = event.form;
    this.mostrarArchivosPaso4 = true;
    if (this.formRelacionPasivos?.valid) {
      this.mostrarArchivosPaso4 = false;
      this.pretencionesPaso4 = this.getTagFileRelacionPasivos(this.formRelacionPasivos);
      setTimeout(() => {
        this.mostrarArchivosPaso4 = true;
      }, 100);
    }
  }

  // <!-- Sección Información financiera con corte al último día calendario del mes anterior-->
  onSubmitSucursalInformacionFinancieraMes(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formInformacionFinancieraMes = event.form;
    this.mostrarArchivosPaso5 = true;
  }

  // <!-- Sección Información financiera con corte al último año anterior-->
  onSubmitSucursalInformacionFinancieraAnio(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = event.form;
    this.formInformacionFinancieraAnio = event.form;
    if (event.controlName == 'tieneIversionesSubsidiarias') {
      const valor = this.formInformacionFinancieraAnio.get('tieneIversionesSubsidiarias')?.value;
      const valorTotalGananciaMetodoParticipacion = this.reorSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoParticipacion'
      );
      const valorTotalGananciaMetodoAlCosto = this.reorSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoAlCosto'
      );
      const valorTotalGananciaMetodoValorRazonable = this.reorSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoValorRazonable'
      );
      if (valor == 1) {
        this.setearObligatorio('valorTotalGananciaMetodoParticipacion',
          this.reorSucursalInformacionFinancieraAnio,
          true)
        this.setearObligatorio('valorTotalGananciaMetodoAlCosto',
          this.reorSucursalInformacionFinancieraAnio,
          true)
        this.setearObligatorio('valorTotalGananciaMetodoValorRazonable',
          this.reorSucursalInformacionFinancieraAnio,
          true)
        if (valorTotalGananciaMetodoParticipacion != undefined ||
          valorTotalGananciaMetodoAlCosto != undefined ||
          valorTotalGananciaMetodoValorRazonable != undefined
        ) {
          formGroup
            .get('valorTotalGananciaMetodoParticipacion')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_DECIMAL),
            ]);
          formGroup
            .get('valorTotalGananciaMetodoAlCosto')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_DECIMAL),
            ]);
          formGroup
            .get('valorTotalGananciaMetodoValorRazonable')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_DECIMAL),
            ]);
        }
        formGroup.get('valorTotalGananciaMetodoParticipacion')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoAlCosto')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoValorRazonable')?.updateValueAndValidity();

      } else {
        this.setearObligatorio('valorTotalGananciaMetodoParticipacion',
          this.reorSucursalInformacionFinancieraAnio,
          false)
        this.setearObligatorio('valorTotalGananciaMetodoAlCosto',
          this.reorSucursalInformacionFinancieraAnio,
          false)
        this.setearObligatorio('valorTotalGananciaMetodoValorRazonable',
          this.reorSucursalInformacionFinancieraAnio,
          false)
        formGroup
          .get('valorTotalGananciaMetodoParticipacion')
          ?.clearValidators();
        formGroup
          .get('valorTotalGananciaMetodoAlCosto')
          ?.clearValidators();
        formGroup
          .get('valorTotalGananciaMetodoValorRazonable')
          ?.clearValidators();
        formGroup.get('valorTotalGananciaMetodoParticipacion')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoAlCosto')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoValorRazonable')?.updateValueAndValidity();

      }
    }
  }

  // <!-- Sección Conjunto completo de estados financieros comparativos-->
  onSubmitSucursalEstadosFinancieros(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formEstadosFinancieros = event.form;
    let formGroup = event.form;
    if (event.controlName == 'informacionRemitida') {
      const valor = this.formEstadosFinancieros.get('informacionRemitida')?.value;
      const radicado2023 = this.reorSucursalEstadosFinancieros.find(
        field => field.name == 'radicado2023'
      );
      const radicado2022 = this.reorSucursalEstadosFinancieros.find(
        field => field.name == 'radicado2022'
      );
      const radicado2021 = this.reorSucursalEstadosFinancieros.find(
        field => field.name == 'radicado2021'
      );
      if (valor == 1) {
        // No se trae archivos
        this.mostrarArchivosPaso7 = false;
        this.idsFilesPasoSiete = [];
        this.setearObligatorio('radicado2023',
          this.reorSucursalEstadosFinancieros,
          true)
        this.setearObligatorio('radicado2022',
          this.reorSucursalEstadosFinancieros,
          true)
        this.setearObligatorio('radicado2021',
          this.reorSucursalEstadosFinancieros,
          true)
        if (radicado2023 != undefined ||
          radicado2022 != undefined ||
          radicado2021 != undefined
        ) {
          formGroup
            .get('radicado2023')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
            ]);
          formGroup
            .get('radicado2022')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
            ]);
          formGroup
            .get('radicado2021')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
            ]);
        }
        formGroup.get('radicado2023')?.updateValueAndValidity();
        formGroup.get('radicado2022')?.updateValueAndValidity();
        formGroup.get('radicado2021')?.updateValueAndValidity();

      } else {
        this.setearObligatorio('radicado2023',
          this.reorSucursalEstadosFinancieros,
          false)
        this.setearObligatorio('radicado2022',
          this.reorSucursalEstadosFinancieros,
          false)
        this.setearObligatorio('radicado2021',
          this.reorSucursalEstadosFinancieros,
          false)
        formGroup
          .get('radicado2023')
          ?.clearValidators();
        formGroup
          .get('radicado2022')
          ?.clearValidators();
        formGroup
          .get('radicado2021')
          ?.clearValidators();
        formGroup.get('radicado2023')?.updateValueAndValidity();
        formGroup.get('radicado2022')?.updateValueAndValidity();
        formGroup.get('radicado2021')?.updateValueAndValidity();
        // Se obtienen los archivos segun regla
        this.mostrarArchivosPaso7 = true;
      }
    }
  }

  // <!-- Sección Otros documentos requeridos-->
  onSubmitSucursalOtrosDocumentos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formOtrosDocumentos = event.form;
    this.mostrarArchivosPaso9 = true;
    if (this.formOtrosDocumentos?.valid) {
      this.mostrarArchivosPaso9 = false;
      setTimeout(() => {
        this.mostrarArchivosPaso9 = true;
      }, 100);
    }
  }

  // <!-- Sección Reporte de bienes sujetos a garantías mobiliarias-->
  onSubmitSucursalReporteBienesMobiliarios(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formReporteBienesMobiliarios = event.form;
    if (this.formReporteBienesMobiliarios?.get('garantiaInmobiliaria')?.value == 1) {
      this.pretencionesPaso10 = this.getTagFileMobiliarios(this.formReporteBienesMobiliarios);
      setTimeout(() => {
        this.mostrarArchivosPaso10 = true;
      }, 100);
    } else {
      this.mostrarArchivosPaso10 = false;
      this.idsFilesPasoTrece = [];
    }
  }

  // <!-- Sección Reporte de bienes sujetos a garantías mobiliarias-->
  onSubmitSucursalDocumentosAdicionales(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formDocumentosAdicionales = event.form;
  }

  setearObligatorio(name: string, form: FormField[], required: boolean) {
    form.forEach(field => {
      if (name == field.name) {
        field.required = required;
      }
    });
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    if (formGroup) {
      const camposRequeridos = Object.keys(formGroup.controls).filter(
        controlName =>
          formGroup.get(controlName)?.hasValidator(Validators.required)
      );
    }
  }

  // Validar formularios validos
  getValidForms(): boolean {
    if (this.validarDocumentosObligatorios(this.formIdentificacionDeudor, this.listaPasosRoi.PASO_1).valido
      && (this.datosRevisores.length > 0 && this.datosContadores.length > 0)
      && this.validarDocumentosObligatorios(this.formInformacionProfesionales, this.listaPasosRoi.PASO_2).valido
      && this.validarPasoTres()
      && this.validarDocumentosObligatorios(this.formRelacionPasivos, this.listaPasosRoi.PASO_5).valido
      && this.validarDocumentosObligatorios(this.formInformacionFinancieraMes, this.listaPasosRoi.PASO_6).valido
      && this.formInformacionFinancieraAnio?.valid
      && this.validarDocumentosObligatorios(this.formEstadosFinancieros, this.listaPasosRoi.PASO_7).valido
      && this.validarOnlyDocumentosObligatorios(this.listaPasosRoi.PASO_8)
      && this.validarPasoNueve()
      && this.formDocumentosAdicionales.valid
    ) {
      return true;
    } else {
      return false;
    }
  }

  // construccion body para servicio
  buildFormTramite(enviar: boolean): TramiteSupersociedadesRoiDto {
    // Revisor
    // Si no existen revisores almacenados, se envían los datos del formulario, si existen
    // revisores almacenados previamente, se envían los datos que vienen del servicio de listar revisores
    let arrayRevisores: ProfesionalDTO[] = [];
    if (this.datosRevisores.length === 0) {
      arrayRevisores = [
        this.construirJSONRevisor()
      ]
    } else {
      arrayRevisores = this.procesarArrayRevisores();
    }
    // Apoderado
    // Si no existen apoderados almacenados, se envían los datos del formulario, si existen
    // apoderados almacenados previamente, se envían los datos que vienen del servicio de listar apoderados
    let arrayApoderados: ProfesionalDTO[] = [];
    if (this.datosApoderados.length === 0) {
      arrayApoderados = [
        this.construirJSONApoderado()
      ]
    } else {
      arrayApoderados = this.procesarArrayApoderados();
    }
    // Contador
    // Si no existen contadores almacenados, se envían los datos del formulario, si existen
    // contadores almacenados previamente, se envían los datos que vienen del servicio de listar contadores
    let arrayContadores: ProfesionalDTO[] = [];
    if (this.datosContadores.length === 0) {
      arrayContadores = [
        this.construirJSONContador()
      ]
    } else {
      arrayContadores = this.procesarArrayContadores();
    }
    // Representante legal
    // Si no existen representantes almacenados, se envían los datos del formulario, si existen
    // representantes almacenados previamente, se envían los datos que vienen del servicio de listar representantes
    let arrayRepresentantes: ProfesionalDTO[] = [];
    if (this.datosRepresentantes.length === 0) {
      arrayRepresentantes = [
        this.construirJSONRepresentante()
      ]
    } else {
      arrayRepresentantes = this.procesarArrayRepresentantes();
    }
    const tramite: TramiteSupersociedadesRoiDto = {
      idCreador: this.idUsuario!,
      id: this.idTramite ?? undefined,
      tipoSolicitante: this.retornarListaValor('tipoSolicitante'),
      idTipoTramite: this.tipoTramite,
      normaAplicable: this.formIdentificacionDeudor?.get('normaAplicable')?.value,
      tipoIdentificacion: { id: this.formIdentificacionDeudor?.get('tipoDeDocumento')?.value },
      numeroIdentificacion: this.formIdentificacionDeudor?.get('numberOfDocument')?.value,
      nombreRazonSocial: this.formIdentificacionDeudor?.get('nombre')?.value,
      codigoCIIU: this.retornarListaValor('codigoCIIU'),
      macrosector: this.retornarListaValor('macrosector'),
      paisDomicilio: { id: this.formIdentificacionDeudor?.get('country')?.value },
      departamentoDomicilio: { id: this.formIdentificacionDeudor?.get('departament')?.value },
      municipioDomicilio: { id: this.formIdentificacionDeudor?.get('municipality')?.value },
      direccionNotificacion: this.formIdentificacionDeudor?.get('addressNotificacion')?.value,
      correoElectronicoNotificacion: this.formIdentificacionDeudor?.get('email')?.value,
      telefono: this.formIdentificacionDeudor?.get('telefono')?.value,
      naturaleza: this.retornarListaValor('naturaleza'),
      porcentajeParticipacionEstatal: this.formIdentificacionDeudor?.get('participacionEstatal')?.value,
      numeroEmpleadosMujeres: this.formIdentificacionDeudor?.get('numeroEmpleadasMujeres')?.value,
      numeroEmpleadosHombres: this.formIdentificacionDeudor?.get('numeroEmpleadosHombres')?.value,
      representanteLegal: { id: this.formInformacionProfesionales?.get('representanteLegal')?.value },
      contador: { id: this.formInformacionProfesionales?.get('contador')?.value },
      revisorFiscal: { id: this.formInformacionProfesionales?.get('revisorFiscal')?.value },
      idApoderado: this.formInformacionProfesionales?.get('apoderado')?.value,
      certificoActividad: this.retornarListaValor('certificoActividad'),
      tienePasivosRetenciones: this.getBooleanValue('tienePasivosRetenciones', this.formRelacionPasivos),
      tienePasivosDescuentos: this.getBooleanValue('tienePasivosDescuentos', this.formRelacionPasivos),
      tienePasivosAportes: this.getBooleanValue('tienePasivosAportes', this.formRelacionPasivos),
      fechaEstadoFinancieroMesAnterior: this.formInformacionFinancieraMes?.get('fechaEstadoFinancieroMesAnterior')?.value,
      valorTotalActivosMesAnterior: this.formInformacionFinancieraMes?.get('valorTotalActivosMesAnterior')?.value,
      valorTotalPasivosMesAnterior: this.formInformacionFinancieraMes?.get('valorTotalPasivosMesAnterior')?.value,
      valorTotalPatrimonioMesAnterior: this.formInformacionFinancieraMes?.get('valorTotalPatrimonioMesAnterior')?.value,
      codigoGrupoPreparadores: this.retornarListaValor('codigoGrupoPreparadores'),
      fechaEstadoFinancieroAnioAnterior: this.formInformacionFinancieraAnio?.get('fechaEstadoFinancieroAnioAnterior')?.value,
      valorTotalActivosAnioAnterior: this.formInformacionFinancieraAnio?.get('valorTotalActivosAnioAnterior')?.value,
      valorTotalPasivosAnioAnterior: this.formInformacionFinancieraAnio?.get('valorTotalPasivosAnioAnterior')?.value,
      valorTotalIngresosOrdinariosAnioAnterior: this.formInformacionFinancieraAnio?.get('valorTotalIngresosOrdinariosAnioAnterior')?.value,
      valorTotalOtrosIngresosAnioAnterior: this.formInformacionFinancieraAnio?.get('valorTotalOtrosIngresosAnioAnterior')?.value,
      tieneInversiones: this.getBooleanValue('tieneIversionesSubsidiarias', this.formInformacionFinancieraAnio),
      valorTotalGananciaMetodoParticipacion: this.formInformacionFinancieraAnio?.get('valorTotalGananciaMetodoParticipacion')?.value,
      valorTotalGananciaMetodoAlCosto: this.formInformacionFinancieraAnio?.get('valorTotalGananciaMetodoAlCosto')?.value,
      valorTotalGananciaMetodoValorRazonable: this.formInformacionFinancieraAnio?.get('valorTotalGananciaMetodoValorRazonable')?.value,
      tieneInformacionRemitida: this.getBooleanValue('informacionRemitida', this.formEstadosFinancieros),
      radicado2023: this.formEstadosFinancieros?.get('radicado2023')?.value,
      radicado2022: this.formEstadosFinancieros?.get('radicado2022')?.value,
      radicado2021: this.formEstadosFinancieros?.get('radicado2021')?.value,
      tieneCausalDisolucion: this.getBooleanValue('causalDisolucion', this.formOtrosDocumentos),
      tienePasivosPensionales: this.getBooleanValue('pasivosPensionales', this.formOtrosDocumentos),
      esGaranteTerceros: this.getBooleanValue('garanteTerceros', this.formOtrosDocumentos),
      tieneBienesGarantiaInmobiliaria: this.getBooleanValue('garantiaInmobiliaria', this.formReporteBienesMobiliarios),
      descripcion: this.formDocumentosAdicionales?.get('descripcion')?.value,
      enviar: enviar,
      revisorFiscalMul: arrayRevisores,
      multiplesApoderados: arrayApoderados,
      contadorMul: arrayContadores,
      representanteMul: arrayRepresentantes
    };
    const tramiteLimpio = this.limpiarObjeto(tramite);
    if (tramiteLimpio.paisDomicilio.id != 1) {
      tramiteLimpio.departamentoExtranjero = this.formIdentificacionDeudor?.get('otroDepartamento')?.value;
      tramiteLimpio.ciudadExtranjero = this.formIdentificacionDeudor?.get('otroMunicipio')?.value;
    }

    return tramiteLimpio;
  }

  getIdSolicitante(codigo: string): number {
    let codigoLista: number = 0;
    this.listaSolicitante.forEach(elemento => {
      if (elemento.Codigo == codigo) {
        codigoLista = +elemento.Id!;
      }
    })
    return codigoLista;
  }

  limpiarObjeto<T extends Record<string, any>>(obj: T): T {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => !(typeof value === 'boolean' && value === undefined))
    ) as T;
  }

  getBooleanValue(controlName: string, form: FormGroup): boolean | undefined {
    const value = form?.get(controlName)?.value;
    return value === undefined ? undefined : value === 1;
  }

  getNombreGrupoPreparadores(idGrupo: number): string {
    let nombre: string = '';
    this.grupoPreparadores.forEach(elemento => {
      if (idGrupo == elemento.Id) {
        nombre = elemento.Nombre;
      }
    })
    return nombre;
  }

  getIdGrupoPreparadores(nombreGrupo: string): number | undefined {
    let id: number = 0;
    this.grupoPreparadores.forEach(elemento => {
      if (nombreGrupo == elemento.Nombre) {
        id = elemento.Id;
      }
    })
    return nombreGrupo.length > 0 ? id : undefined;
  }

  // Envio formulario
  async onSubmitFormulario(enviar: boolean) {
    this.enviarEntidad = enviar;

    let tramite = this.buildFormTramite(enviar);
    this.serviceRoi.crearTramiteSSRoiSucursal(tramite).subscribe(
      async response => {
        if (response.success) {
          this.idTramite = response.data?.Id!;
          this.idTramiteSsoRoi = response.data?.Id!;
          if (enviar) {
            this.enviarDocumentos = true;
            this.alertaModalService
              .exito(
                this.alertaText['proceso-enviado'],
                this.alertaText['asuntos-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad),
              )
              .then(() => {
                this.router.navigate(['/expediente']);
              });
          } else {
            this.enviarDocumentos = true;
            this.alertaModalService.exito(
              this.alertaText['asuntos-alertas']['tramite-guardado']
            );
          }
        }
      },
      err => {
        console.error(err);
      }
    );
  }

  get isFormularioInvalido(): boolean {
    return this.formTipoRevisor?.invalid
      || this.formRevisorPN?.invalid
      || this.formRevisorPJ?.invalid
      || this.formTipoApoderado?.invalid
      || this.formApoderadoPN?.invalid
      || this.formApoderadoPJ?.invalid
      || this.formTipoContador?.invalid
      || this.formContadorPN?.invalid
      || this.formContadorPJ?.invalid
      || this.formTipoRepresentante?.invalid
      || this.formRepresentantePN?.invalid
      || this.formRepresentantePJ?.invalid
      || false;
  }

  // Get data usuario logeado

  getData() {
    this.dataUsuario = this.textTransformService.transformarAMayusculas(this.dataUsuario);

    // Si es extranjero
    if (this.dataUsuario?.pais !== 1) {
      this._cuentaService.getDataPersonal(this.dataUsuario.idUsuario!).subscribe((response: any) => {
        if (response.status === 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }
        this.mapearFormularioDeudor();
      });
      this.reorSucursalIdentificacionDeudor.forEach(field => {
        if (['otroMunicipio', 'otroDepartamento'].includes(field.name)) {
          field.required = true;
        }
      });
    } else {
      this.mapearFormularioDeudor();
    }
  }

  mapearFormularioDeudor() {
    setTimeout(() => {
      this.reorSucursalIdentificacionDeudor = this.reorSucursalIdentificacionDeudor.map(field => {
        switch (field.name) {
          case 'tipoDeDocumento':
            field.value = this.getIdDocumento(String(this.dataUsuario.tipoDocumento));
            break;
          case 'numberOfDocument':
            field.value = this.dataUsuario.identificacion;
            break;
          case 'nombre':
            field.value = this.dataUsuario.primerNombre;
            break;
          case 'country':
            field.value = this.dataUsuario.pais;
            break;
          case 'departament':
            field.value = this.dataUsuario.departamento;
            break;
          case 'municipality':
            field.value = this.dataUsuario.municipio;
            break;
          case 'otroDepartamento':
            field.value = this.dataUsuario.otroDepartamento ?? '';
            break;
          case 'otroMunicipio':
            field.value = this.dataUsuario.otroMunicipio ?? '';
            break;
          case 'addressNotificacion':
            field.value = this.dataUsuario?.direccion?.find(
              (elemento: {
                Direccion_Notificacion?: string;
                Es_Primaria?: boolean;
                Id?: number
              }) => elemento.Es_Primaria
            )?.Direccion_Notificacion ??
              this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
            break;
          case 'email':
            field.value = this.dataUsuario.correoElectronico;
            break;
          case 'telefono':
            field.value = this.dataUsuario.telefonoPrincipal;
            break;


        }
        return field;
      });
    }, 800);

  }

  // obtiene el id del tipo de documento por nombre
  getIdDocumento(tipoDocumento: string): number {
    if (typeof tipoDocumento == 'string') {
      const documento = this.listaTiposDocumento.find(
        (elemento: any) => elemento.TipoDocumento === tipoDocumento
      );
      return +documento?.Id!;
    } else {
      return tipoDocumento[0];
    }
  }

  // Obtener tags para Files segun paso
  getTagFileAdmisibilidad(codigo: string): string {
    let tag: string = "";
    this.listaCertificoActividad.forEach(elemento => {
      if (codigo == 'INCAPACIDAD_PAGO') {
        tag = "incapacidadPago";
      } else {
        tag = "cesePago";
      }
    })
    return tag;
  }

  getTagFileRelacionPasivos(form: FormGroup): string {
    let tag: string = "";
    const formValues = form.getRawValue();
    tag = Object.keys(formValues)
      .filter(key => formValues[key] === 1)
      .join(",");
    return tag;
  }

  getTagFileOtrosDocumentos(form: FormGroup): string {
    let tag: string = "";
    const formValues = form.getRawValue();
    const additionalTags = Object.keys(formValues)
      .filter(key => formValues[key] === 1)
      .join(",");
    if (additionalTags) {
      tag = `${tag},${additionalTags}`;
    }
    if (formValues['causalDisolucion'] === 1) {
      tag = `${tag},causalSiDisolucion`;
    } else if (formValues['causalDisolucion'] === 2) {
      tag = `${tag},causalNoDisolucion`;
    }
    tag = tag
      .split(",")
      .filter(word => word !== "causalDisolucion")
      .join(",");
    return tag;
  }

  getTagFileMobiliarios(form: FormGroup): string {
    let tag: string = "";
    const formValues = form.getRawValue();
    tag = Object.keys(formValues)
      .filter(key => formValues[key] === 1)
      .join(",");
    return tag;
  }


  // Documentos
  subirArchivo(subio: any) {
    this.enviarDocumentos = false;
    if (subio) {
    }
  }

  validarArchivosCargados(archivos: ArchivoItemDto[], paso: number) {
    switch (paso) {
      case 1:
        this.archivosCargadosPasoUno = archivos;
        break;
      case 2:
        this.archivosCargadosPasoDos = archivos;
        break;
      case 3:
        this.archivosCargadosPasoTres = archivos;
        break;
      case 4:
        this.archivosCargadosPasoCuatro = archivos;
        break;
      case 5:
        this.archivosCargadosPasoCinco = archivos;
        break;
      case 6:
        this.archivosCargadosPasoSeis = archivos;
        break;
      case 7:
        this.archivosCargadosPasoSiete = archivos;
        break;
      case 8:
        this.archivosCargadosPasoOcho = archivos;
        break;
      case 9:
        this.archivosCargadosPasoNueve = archivos;
        break;
      case 10:
        this.archivosCargadosPasoDiez = archivos;
        break;
      case 11:
        this.archivosCargadosPasoOnce = archivos;
        break;
      case 12:
        this.archivosCargadosPasoDoce = archivos;
        break;
      case 13:
        this.archivosCargadosPasoTrece = archivos;
        break;
      case 14:
        this.archivosCargadosPasoCatorce = archivos;
        break;

    }
  }

  getFileRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    switch (evento.paso) {
      case 1:
        this.idsFilesPasoUno = this.searchRequired(evento.archivos);
        break;
      case 2:
        this.idsFilesPasoDos = this.searchRequired(evento.archivos);
        break;
      case 3:
        this.idsFilesPasoTres = this.searchRequired(evento.archivos);
        break;
      case 4:
        this.idsFilesPasoCuatro = this.searchRequired(evento.archivos);
        break;
      case 5:
        this.idsFilesPasoCinco = this.searchRequired(evento.archivos);
        break;
      case 6:
        this.idsFilesPasoSeis = this.searchRequired(evento.archivos);
        break;
      case 7:
        this.idsFilesPasoSiete = this.searchRequired(evento.archivos);
        break;
      case 8:
        this.idsFilesPasoOcho = this.searchRequired(evento.archivos);
        break;
      case 9:
        this.idsFilesPasoNueve = this.searchRequired(evento.archivos);
        break;
      case 10:
        this.idsFilesPasoDiez = this.searchRequired(evento.archivos);
        break;
      case 11:
        this.idsFilesPasoOnce = this.searchRequired(evento.archivos);
        break;
      case 12:
        this.idsFilesPasoDoce = this.searchRequired(evento.archivos);
        break;
      case 13:
        this.idsFilesPasoTrece = this.searchRequired(evento.archivos);
        break;
      case 14:
        this.idsFilesPasoCatorce = this.searchRequired(evento.archivos);
        break;
    }
  }

  searchRequired(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }

  validarDocumentosObligatorios(form: FormGroup, paso: number): {
    valido: boolean,
    error?: string
  } {
    let checkAnexos: boolean = false;
    let formulario: boolean = false;
    let anexosRequeridosIds: any;
    switch (paso) {
      case 1:
        anexosRequeridosIds = this.idsFilesPasoUno.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoUno, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 2:
        anexosRequeridosIds = this.idsFilesPasoDos.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoDos, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 4:
        anexosRequeridosIds = this.idsFilesPasoCuatro.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoCuatro, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 5:
        anexosRequeridosIds = this.idsFilesPasoCinco.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoCinco, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 6:
        anexosRequeridosIds = this.idsFilesPasoSeis.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoSeis, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 7:
        anexosRequeridosIds = this.idsFilesPasoSiete.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoSiete, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 8:
        anexosRequeridosIds = this.idsFilesPasoOcho.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoOcho, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 9:
        anexosRequeridosIds = this.idsFilesPasoNueve.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoNueve, anexosRequeridosIds);
        formulario = form.valid;
        break;
      case 13:
        anexosRequeridosIds = this.idsFilesPasoTrece.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoTrece, anexosRequeridosIds);
        formulario = form.valid;
        break;
    }
    if (!formulario) {
      return { valido: false, error: Constants.FORM_INVALID };
    }
    if (!checkAnexos) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    return { valido: true };
  }

  validarOnlyDocumentosObligatorios(paso: number): boolean {
    let checkAnexos: boolean = false;
    let anexosRequeridosIds: any;
    switch (paso) {
      case 3:
        anexosRequeridosIds = this.idsFilesPasoTres.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoTres, anexosRequeridosIds);
        break;
      case 8:
        anexosRequeridosIds = this.idsFilesPasoOcho.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoOcho, anexosRequeridosIds);
        break;
      case 10:
        anexosRequeridosIds = this.idsFilesPasoDiez.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoDiez, anexosRequeridosIds);
        break;
      case 11:
        anexosRequeridosIds = this.idsFilesPasoOnce.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoOnce, anexosRequeridosIds);
        break;
      case 12:
        anexosRequeridosIds = this.idsFilesPasoDoce.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.isEmptyAnexo(this.archivosCargadosPasoDoce, anexosRequeridosIds);
        break;
    }
    if (checkAnexos) {
      return true;
    } else {
      return false;
    }
  }

  validarPasoTres(): { valido: boolean, error?: string } {
    const admisibilidad = this.validarDocumentosObligatorios(this.formSupuestosAdmisibilidad, this.listaPasosRoi.PASO_4);
    if (!admisibilidad.valido) {
      return { valido: false, error: admisibilidad.error };
    }
    const fileMemoriaExplicativa = this.validarOnlyDocumentosObligatorios(this.listaPasosRoi.PASO_3);

    if (!fileMemoriaExplicativa) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    return { valido: true };

  }

  validarPasoNueve(): { valido: boolean, error?: string } {
    const pasoNueveValido = this.validarDocumentosObligatorios(this.formOtrosDocumentos, this.listaPasosRoi.PASO_9);

    if (!pasoNueveValido.valido) {
      return { valido: false, error: pasoNueveValido.error };
    }
    const fileDiezValido = this.validarOnlyDocumentosObligatorios(this.listaPasosRoi.PASO_10);

    if (!fileDiezValido) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    const fileOnceValido = this.validarOnlyDocumentosObligatorios(this.listaPasosRoi.PASO_11);
    if (!fileOnceValido) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    const fileDoceValido = this.validarOnlyDocumentosObligatorios(this.listaPasosRoi.PASO_12);
    if (!fileDoceValido) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    const bienesMobiliarios = this.validarDocumentosObligatorios(this.formReporteBienesMobiliarios, this.listaPasosRoi.PASO_13)
    if (!bienesMobiliarios.valido) {
      return { valido: false, error: bienesMobiliarios.error };
    }
    return { valido: true };
  }

  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    if (requeridosFull == cantidadRequeridos) {
      return true;
    } else {
      return false;
    }
  }

  getFilesPrecargadosByPaso(paso: number): AnexoPrecargaResponseDto[] {
    return this.tramiteRoi?.anexos?.filter(
      elemento => elemento.tipoAnexoTipoTramite.orden === paso
    ) || [];
  }

  onContinue(form: FormGroup, paso: number, event: any) {
    const result = this.validarDocumentosObligatorios(form, paso);

    if (!result.valido) {
      if (result.error === Constants.FORM_INVALID) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        form.markAllAsTouched();
        return;
      }

      if (result.error === Constants.ANEXOS_INCOMPLETOS) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['archivos_obligatorios']
        );
        return;
      }

      return;
    }
    // si es válido → seguir flujo JS
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueRevisoresContadores(event: any) {
    if (this.datosRevisores.length === 0 || this.datosContadores.length === 0 || this.datosRepresentantes.length == 0) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // si todo es válido → avanzar
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinuePasoTres(event: any) {
    const result = this.validarPasoTres();

    if (!result.valido) {

      switch (result.error) {

        case Constants.FORM_INVALID:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          this.formSupuestosAdmisibilidad.markAllAsTouched();
          return;

        case Constants.ANEXOS_INCOMPLETOS:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          return;
      }

      return;
    }

    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueInfoFinanciera(event: any) {
    if (this.formInformacionFinancieraAnio.invalid) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      this.formInformacionFinancieraAnio.markAllAsTouched();
      return;
    }
    // Todo válido → ejecutar script JS externo
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueOnlyDocs(paso: number, event: any) {
    const esValido = this.validarOnlyDocumentosObligatorios(paso);

    if (!esValido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }

    // Si los anexos requeridos están cargados, avanzamos
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinuePasoNueve(event: any) {
    const result = this.validarPasoNueve();

    if (!result.valido) {

      switch (result.error) {

        case Constants.FORM_INVALID:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          this.formOtrosDocumentos.markAllAsTouched();
          this.formReporteBienesMobiliarios.markAllAsTouched();
          return;

        case Constants.ANEXOS_INCOMPLETOS:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          return;
      }

      return;
    }

    // Todo válido → avanzar al siguiente paso
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueFinalizar(event: any) {
    const esValido = this.getValidForms();

    if (!esValido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    // Todo está OK → ejecutar el submit real
    this.onSubmitFormulario(true);
  }


  anterior(paso: number) {
  }


  habilitarTipoRevisor() {
    this.mostrarTipoRevisor = true;
  }

  habilitarTipoApoderado() {
    this.mostrarTipoApoderado = true;
  }

  habilitarTipoContador() {
    this.mostrarTipoContador = true;
  }

  habilitarTipoRepresentante() {
    this.mostrarTipoRepresentante = true;
  }

  eliminarRevisor(evento: object) {
    const item = evento as ItemTablaDTO;
    this.serviceRoi.eliminarRevisor(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_eliminado']);
        this.listarRevisores();
        this.listaSimpleRevisores();
      }
    });
  }

  eliminarApoderado(evento: object) {
    const item = evento as ItemTablaDTO;
    this.serviceRoi.eliminarApoderado(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_eliminado']);
        this.listarApoderados();
        this.listaSimpleApoderados();
      }
    });
  }

  eliminarContador(evento: object) {
    const item = evento as ItemTablaDTO;
    this.serviceRoi.eliminarContador(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_eliminado']);
        this.listarContadores();
        this.listaSimpleContadores();
      }
    });
  }

  eliminarRepresentante(evento: object) {
    let item = evento as ItemTablaDTO;
    this.serviceRoi.eliminarRepresentante(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal_eliminado']);
        this.listarRepresentantes();
        this.listaSimpleRepresentantes();
      }
    });
  }

  // Se consume el servicio de listar revisores fiscales
  listarRevisores() {
    this.serviceRoi.listaRevisores(1, Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosRevisores = resp.datos;
      });
  }

  // Se consume el servicio de listar apoderados
  listarApoderados() {
    this.serviceRoi.listaApoderados(1, Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosApoderados = resp.datos;
      });
  }

  // Se consume el servicio de listar contadores
  listarContadores() {
    this.serviceRoi.listaContadores(1, Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosContadores = resp.datos;
      });
  }

  // Se consume el servicio de listar representantes
  listarRepresentantes() {
    this.serviceRoi.listaRepresentantes(1, Constants.CODIGO_ROI,
      this.getIdSolicitante(this.nombreTipoSolicitante!), this.idTramite)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosRepresentantes = resp.datos;
      });
  }

  guardarProfesional(esEnviar: boolean, profesional: string) {
    const proceso = this.buildFormTramite(esEnviar);
    this.serviceRoi.crearTramiteSSRoiSociedad(proceso).subscribe((resp: TramiteResponseDTO) => {
      if (resp.success) {
        this.idTramite = resp.data?.Id!;
        if (profesional == 'revisor') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_agregado']);
          this.listarRevisores();
          this.listaSimpleRevisores();
          this.formTipoRevisor?.reset();
          this.formRevisorPN?.reset();
          this.formRevisorPJ?.reset();
          this.mostrarTipoRevisor = false;
          this.mostrarRevisorPN = false;
          this.mostrarRevisorPJ = false;
          this.formTipoRevisor = undefined;
          this.formRevisorPN = undefined;
          this.formRevisorPJ = undefined;
        }
        if (profesional == 'apoderado') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_agregado']);
          this.listarApoderados();
          this.listaSimpleApoderados();
          this.formTipoApoderado?.reset();
          this.formApoderadoPN?.reset();
          this.formApoderadoPJ?.reset();
          this.mostrarTipoApoderado = false;
          this.mostrarApoderadoPN = false;
          this.mostrarApoderadoPJ = false;
          this.formTipoApoderado = undefined;
          this.formApoderadoPN = undefined;
          this.formApoderadoPJ = undefined;
        }
        if (profesional == 'contador') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_agregado']);
          this.listarContadores();
          this.listaSimpleContadores();
          this.formTipoContador?.reset();
          this.formContadorPN?.reset();
          this.formContadorPJ?.reset();
          this.mostrarTipoContador = false;
          this.mostrarContadorPN = false;
          this.mostrarContadorPJ = false;
          this.formTipoContador = undefined;
          this.formContadorPN = undefined;
          this.formContadorPJ = undefined;
        }
        if (profesional == 'representante') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal_agregado']);
          this.listarRepresentantes();
          this.listaSimpleRepresentantes();
          this.formTipoRepresentante?.reset();
          this.formRepresentantePN?.reset();
          this.formRepresentantePJ?.reset();
          this.mostrarTipoRepresentante = false;
          this.mostrarRepresentantePN = false;
          this.mostrarRepresentantePJ = false;
          this.formTipoRepresentante = undefined;
          this.formRepresentantePN = undefined;
          this.formRepresentantePJ = undefined;
        }
      } else {
        this.alertaModalService.error(resp.message);
      }
    });
  }

  capturarFormTipoRevisor(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formTipoRevisor = evento.form;
    }, 100);
    // Se verifica si el tipo de revisor seleccionado es persona natural o jurídica
    if (evento.controlName == 'tipoPersonaRevisor') {
      const tipo = evento.controlValue as FormFieldOption;
      // Revisor persona natural
      if (tipo.Id == 1) {
        this.mostrarRevisorPN = true;
        this.mostrarRevisorPJ = false;
        this.formRevisorPJ?.reset();
      }
      // Revisor persona jurídica
      if (tipo.Id == 2) {
        this.mostrarRevisorPJ = true;
        this.mostrarRevisorPN = false;
        this.formRevisorPN?.reset();
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormRevisorPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRevisorPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormRevisorPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRevisorPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormTipoApoderado(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formTipoApoderado = evento.form;
    }, 100);
    if (evento.controlName == 'tipoPersonaApoderado') {
      let tipo = evento.controlValue as FormFieldOption;
      // Apoderado persona natural
      if (tipo.Id == 1) {
        this.mostrarApoderadoPN = true;
        this.mostrarApoderadoPJ = false;
        this.formApoderadoPJ?.reset();
      }
      // Apoderado persona jurídica
      if (tipo.Id == 2) {
        this.mostrarApoderadoPJ = true;
        this.mostrarApoderadoPN = false;
        this.formApoderadoPN?.reset();
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormApoderadoPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formApoderadoPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormApoderadoPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formApoderadoPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormTipoContador(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formTipoContador = evento.form;
    }, 100);
    if (evento.controlName == 'tipoPersonaContador') {
      let tipo = evento.controlValue as FormFieldOption;
      // Contador persona natural
      if (tipo.Id == 1) {
        this.mostrarContadorPN = true;
        this.mostrarContadorPJ = false;
        this.formContadorPJ?.reset();
      }
      // Contador persona jurídica
      if (tipo.Id == 2) {
        this.mostrarContadorPJ = true;
        this.mostrarContadorPN = false;
        this.formContadorPN?.reset();
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormContadorPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formContadorPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormContadorPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formContadorPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormTipoRepresentante(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formTipoRepresentante = evento.form;
    }, 100);
    if (evento.controlName == 'tipoPersonaRepresentante') {
      let tipo = evento.controlValue as FormFieldOption;
      // Representante persona natural
      if (tipo.Id == 1) {
        this.mostrarRepresentantePN = true;
        this.mostrarRepresentantePJ = false;
        this.formRepresentantePJ?.reset();
      }
      // Representante persona jurídica
      if (tipo.Id == 2) {
        this.mostrarRepresentantePJ = true;
        this.mostrarRepresentantePN = false;
        this.formRepresentantePN?.reset();
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarFormRepresentantePN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRepresentantePN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }

  capturarRepresentantePJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRepresentantePJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
    const tramite = this.buildFormTramite(false);
    this.formSucursalOutput?.emit(tramite);
  }
  protected readonly Constants = Constants;
  // Función que recorre la lista de revisores y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayRevisores() {
    let arrayRevisores: ProfesionalDTO[] = [];
    // Si existen revisores almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoRevisor) {
      if (this.formTipoRevisor.get('tipoPersonaRevisor')?.value == 1) {
        if (this.formRevisorPN?.valid) {
          arrayRevisores.push(this.construirJSONRevisor());
        }
      } else if (this.formTipoRevisor.get('tipoPersonaRevisor')?.value == 2) {
        if (this.formRevisorPJ?.valid) {
          arrayRevisores.push(this.construirJSONRevisor());
        }
      }
    }
    this.datosRevisores.forEach(revisor => {
      arrayRevisores.push({
        id: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Id_Persona
          : revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: revisor.persona.Id_Tipo_Persona == 2
          ? revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: revisor.persona.Id_Tipo_Persona,
        idTipoIdentificacion: revisor.persona.Id_Tipo_Identificacion,
        identificacion: revisor.persona.Identificacion,
        primerNombre: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: revisor.persona.Id_Tipo_Persona == 2
          ? revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: revisor.persona.Municipio.Departamento.Pais.Id
          ? { id: revisor.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: revisor.persona.Municipio.Departamento.Id
          ? { id: revisor.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: revisor.persona.Municipio.Id
          ? { id: revisor.persona.Municipio.Id }
          : undefined,
        otroDepartamento: revisor.persona.Otro_Departamento
          ? revisor.persona.Otro_Departamento
          : null,
        otroMunicipio: revisor.persona.Otro_Municipio
          ? revisor.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: revisor.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: revisor.persona.Telefono_Principal,
        correoElectronico: revisor.persona.Correo_electronico
      });
    });
    return arrayRevisores;
  }
  // Función que recorre la lista de apoderados y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayApoderados() {
    let arrayApoderados: ProfesionalDTO[] = [];
    // Si existen apoderados almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoApoderado) {
      if (this.formTipoApoderado.get('tipoPersonaApoderado')?.value == 1) {
        if (this.formApoderadoPN?.valid) {
          arrayApoderados.push(this.construirJSONApoderado());
        }
      } else if (this.formTipoApoderado.get('tipoPersonaApoderado')?.value == 2) {
        if (this.formApoderadoPJ?.valid) {
          arrayApoderados.push(this.construirJSONApoderado());
        }
      }
    }
    this.datosApoderados.forEach(apoderado => {
      arrayApoderados.push({
        id: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Id_Persona
          : apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: apoderado.persona.Id_Tipo_Persona == 2
          ? apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: apoderado.persona.Id_Tipo_Persona,
        idTipoIdentificacion: apoderado.persona.Id_Tipo_Identificacion,
        identificacion: apoderado.persona.Identificacion,
        primerNombre: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: apoderado.persona.Id_Tipo_Persona == 2
          ? apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: apoderado.persona.Municipio.Departamento.Pais.Id
          ? { id: apoderado.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: apoderado.persona.Municipio.Departamento.Id
          ? { id: apoderado.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: apoderado.persona.Municipio.Id
          ? { id: apoderado.persona.Municipio.Id }
          : undefined,
        otroDepartamento: apoderado.persona.Otro_Departamento
          ? apoderado.persona.Otro_Departamento
          : null,
        otroMunicipio: apoderado.persona.Otro_Municipio
          ? apoderado.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: apoderado.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: apoderado.persona.Telefono_Principal,
        correoElectronico: apoderado.persona.Correo_electronico
      });
    });
    return arrayApoderados;
  }
  // Función que recorre la lista de contadores y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayContadores() {
    let arrayContadores: ProfesionalDTO[] = [];
    // Si existen contadores almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoContador) {
      if (this.formTipoContador.get('tipoPersonaContador')?.value == 1) {
        if (this.formContadorPN?.valid) {
          arrayContadores.push(this.construirJSONContador());
        }
      } else if (this.formTipoContador.get('tipoPersonaContador')?.value == 2) {
        if (this.formContadorPJ?.valid) {
          arrayContadores.push(this.construirJSONContador());
        }
      }
    }
    this.datosContadores.forEach(contador => {
      arrayContadores.push({
        id: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Id_Persona
          : contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: contador.persona.Id_Tipo_Persona == 2
          ? contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: contador.persona.Id_Tipo_Persona,
        idTipoIdentificacion: contador.persona.Id_Tipo_Identificacion,
        identificacion: contador.persona.Identificacion,
        primerNombre: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: contador.persona.Id_Tipo_Persona == 2
          ? contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: contador.persona.Municipio.Departamento.Pais.Id
          ? { id: contador.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: contador.persona.Municipio.Departamento.Id
          ? { id: contador.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: contador.persona.Municipio.Id
          ? { id: contador.persona.Municipio.Id }
          : undefined,
        otroDepartamento: contador.persona.Otro_Departamento
          ? contador.persona.Otro_Departamento
          : null,
        otroMunicipio: contador.persona.Otro_Municipio
          ? contador.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: contador.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: contador.persona.Telefono_Principal,
        correoElectronico: contador.persona.Correo_electronico
      });
    });
    return arrayContadores;
  }
  // Función que recorre la lista de representantes y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayRepresentantes() {
    let arrayRepresentantes: ProfesionalDTO[] = [];
    // Si existen contadores almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoRepresentante) {
      if (this.formTipoRepresentante.get('tipoPersonaRepresentante')?.value == 1) {
        if (this.formRepresentantePN?.valid) {
          arrayRepresentantes.push(this.construirJSONRepresentante());
        }
      } else if (this.formTipoRepresentante.get('tipoPersonaRepresentante')?.value == 2) {
        if (this.formRepresentantePJ?.valid) {
          arrayRepresentantes.push(this.construirJSONRepresentante());
        }
      }
    }
    this.datosRepresentantes.forEach(representante => {
      arrayRepresentantes.push({
        id: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Id_Persona
          : representante.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: representante.persona.Id_Tipo_Persona == 2
          ? representante.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: representante.persona.Id_Tipo_Persona,
        idTipoIdentificacion: representante.persona.Id_Tipo_Identificacion,
        identificacion: representante.persona.Identificacion,
        primerNombre: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: representante.persona.Id_Tipo_Persona == 1
          ? representante.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: representante.persona.Id_Tipo_Persona == 2
          ? representante.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: representante.persona.Municipio.Departamento.Pais.Id
          ? { id: representante.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: representante.persona.Municipio.Departamento.Id
          ? { id: representante.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: representante.persona.Municipio.Id
          ? { id: representante.persona.Municipio.Id }
          : undefined,
        otroDepartamento: representante.persona.Otro_Departamento
          ? representante.persona.Otro_Departamento
          : null,
        otroMunicipio: representante.persona.Otro_Municipio
          ? representante.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: representante.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: representante.persona.Telefono_Principal,
        correoElectronico: representante.persona.Correo_electronico
      });
    });
    return arrayRepresentantes;
  }
  // Función que construye el JSON de revisores, con los datos de los formularios
  construirJSONRevisor() {
    const idPaisRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['country']?.value
      : this.formRevisorPJ?.controls['country']?.value;
    const idDepartamentoRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['departament']?.value
      : this.formRevisorPJ?.controls['departament']?.value;
    const idMunicipioRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['municipality']?.value
      : this.formRevisorPJ?.controls['municipality']?.value;
    const direccionRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['direccion']?.value
      : this.formRevisorPJ?.controls['direccion']?.value;
    return {
      idTipoPersona: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value,
      idTipoIdentificacion: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['typeOfDocument']?.value
        : this.formRevisorPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['numberOfDocument']?.value
        : this.formRevisorPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formRevisorPN?.controls['primerNombre']?.value,
      segundoNombre: this.formRevisorPN?.controls['segundoNombre']?.value,
      primerApellido: this.formRevisorPN?.controls['primerApellido']?.value,
      segundoApellido: this.formRevisorPN?.controls['segundoApellido']?.value,
      razonSocial: this.formRevisorPJ?.controls['razonSocial']?.value,
      pais: idPaisRevisor ? { id: idPaisRevisor } : undefined,
      departamento: idDepartamentoRevisor ? { id: idDepartamentoRevisor } : undefined,
      municipio: idMunicipioRevisor ? { id: idMunicipioRevisor } : undefined,
      otroDepartamento: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['otroDepartamento']?.value
        : this.formRevisorPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['otroMunicipio']?.value
        : this.formRevisorPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionRevisor ? [{ direccionNotificacion: direccionRevisor }] : undefined,
      telefonoPrincipal: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['telefono']?.value
        : this.formRevisorPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['correo']?.value
        : this.formRevisorPJ?.controls['correo']?.value
    }
  }
  // Función que construye el JSON de apoderados, con los datos de los formularios
  construirJSONApoderado() {
    const idPaisApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['country']?.value
      : this.formApoderadoPJ?.controls['country']?.value;
    const idDepartamentoApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['departament']?.value
      : this.formApoderadoPJ?.controls['departament']?.value;
    const idMunicipioApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['municipality']?.value
      : this.formApoderadoPJ?.controls['municipality']?.value;
    const direccionApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['direccion']?.value
      : this.formApoderadoPJ?.controls['direccion']?.value
    return {
      idTipoPersona: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value,
      idTipoIdentificacion: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['typeOfDocument']?.value
        : this.formApoderadoPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['numberOfDocument']?.value
        : this.formApoderadoPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formApoderadoPN?.controls['primerNombre']?.value,
      segundoNombre: this.formApoderadoPN?.controls['segundoNombre']?.value,
      primerApellido: this.formApoderadoPN?.controls['primerApellido']?.value,
      segundoApellido: this.formApoderadoPN?.controls['segundoApellido']?.value,
      razonSocial: this.formApoderadoPJ?.controls['razonSocial']?.value,
      pais: idPaisApoderado ? { id: idPaisApoderado } : undefined,
      departamento: idDepartamentoApoderado ? { id: idDepartamentoApoderado } : undefined,
      municipio: idMunicipioApoderado ? { id: idMunicipioApoderado } : undefined,
      otroDepartamento: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['otroDepartamento']?.value
        : this.formApoderadoPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['otroMunicipio']?.value
        : this.formApoderadoPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionApoderado ? [{ direccionNotificacion: direccionApoderado }] : undefined,
      telefonoPrincipal: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['telefono']?.value
        : this.formApoderadoPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['correo']?.value
        : this.formApoderadoPJ?.controls['correo']?.value
    }
  }
  // Función que construye el JSON de contadores, con los datos de los formularios
  construirJSONContador() {
    const idPaisContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['country']?.value
      : this.formContadorPJ?.controls['country']?.value;
    const idDepartamentoContador = this.formTipoContador?.controls['tipoPersonaContador'].value == 1
      ? this.formContadorPN?.controls['departament']?.value
      : this.formContadorPJ?.controls['departament']?.value;
    const idMunicipioContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['municipality']?.value
      : this.formContadorPJ?.controls['municipality']?.value;
    const direccionContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['direccion']?.value
      : this.formContadorPJ?.controls['direccion']?.value;
    return {
      idTipoPersona: this.formTipoContador?.controls['tipoPersonaContador']?.value,
      idTipoIdentificacion: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['typeOfDocument']?.value
        : this.formContadorPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['numberOfDocument']?.value
        : this.formContadorPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formContadorPN?.controls['primerNombre']?.value,
      segundoNombre: this.formContadorPN?.controls['segundoNombre']?.value,
      primerApellido: this.formContadorPN?.controls['primerApellido']?.value,
      segundoApellido: this.formContadorPN?.controls['segundoApellido']?.value,
      razonSocial: this.formContadorPJ?.controls['razonSocial']?.value,
      pais: idPaisContador ? { id: idPaisContador } : undefined,
      departamento: idDepartamentoContador ? { id: idDepartamentoContador } : undefined,
      municipio: idMunicipioContador ? { id: idMunicipioContador } : undefined,
      otroDepartamento: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['otroDepartamento']?.value
        : this.formContadorPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['otroMunicipio']?.value
        : this.formContadorPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionContador ? [{ direccionNotificacion: direccionContador }] : undefined,
      telefonoPrincipal: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['telefono']?.value
        : this.formContadorPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['correo']?.value
        : this.formContadorPJ?.controls['correo']?.value
    }
  }
  // Función que construye el JSON de representante, con los datos de los formularios
  construirJSONRepresentante() {
    const idPaisRepresentante = this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value
      ? this.formRepresentantePN?.controls['country']?.value
      : this.formRepresentantePJ?.controls['country']?.value;
    const idDepartamentoRepresentante = this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
      ? this.formRepresentantePN?.controls['departament']?.value
      : this.formRepresentantePJ?.controls['departament']?.value;
    const idMunicipioRepresentante = this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
      ? this.formRepresentantePN?.controls['municipality']?.value
      : this.formRepresentantePJ?.controls['municipality']?.value;
    const direccionRepresentante = this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
      ? this.formRepresentantePN?.controls['direccion']?.value
      : this.formRepresentantePJ?.controls['direccion']?.value;
    return {
      idTipoPersona: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value,
      idTipoIdentificacion: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['typeOfDocument']?.value
        : this.formRepresentantePJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['numberOfDocument']?.value
        : this.formRepresentantePJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formRepresentantePN?.controls['primerNombre']?.value,
      segundoNombre: this.formRepresentantePN?.controls['segundoNombre']?.value,
      primerApellido: this.formRepresentantePN?.controls['primerApellido']?.value,
      segundoApellido: this.formRepresentantePN?.controls['segundoApellido']?.value,
      razonSocial: this.formRepresentantePJ?.controls['razonSocial']?.value,
      pais: idPaisRepresentante ? { id: idPaisRepresentante } : undefined,
      departamento: idDepartamentoRepresentante ? { id: idDepartamentoRepresentante } : undefined,
      municipio: idMunicipioRepresentante ? { id: idMunicipioRepresentante } : undefined,
      otroDepartamento: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['otroDepartamento']?.value
        : this.formRepresentantePJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['otroMunicipio']?.value
        : this.formRepresentantePJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionRepresentante ? [{ direccionNotificacion: direccionRepresentante }] : undefined,
      telefonoPrincipal: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['telefono']?.value
        : this.formRepresentantePJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoRepresentante?.controls['tipoPersonaRepresentante']?.value == 1
        ? this.formRepresentantePN?.controls['correo']?.value
        : this.formRepresentantePJ?.controls['correo']?.value
    }
  }

  // Función que retorna el objeto completo de ListaValor
  retornarListaValor(lista: string) {
    switch (lista) {
      case 'tipoSolicitante':
        return this.listaTipoSolicitantes.find((item: ListaValorRequestDto) =>
          item.codigo == this.nombreTipoSolicitante);
      case 'codigoCIIU':
        return this.listaCodigosCIIU.find((item: ListaValorRequestDto) =>
          item.otroValor == this.formIdentificacionDeudor.controls['codigoCIIU']?.value);
      case 'macrosector':
        return this.listaMacrosector.find((item: ListaValorRequestDto) =>
          item.id == this.formIdentificacionDeudor.controls['macrosector']?.value);
      case 'naturaleza':
        return this.listaNaturaleza.find((item: ListaValorRequestDto) =>
          item.codigo == this.formIdentificacionDeudor.controls['naturaleza'].value);
      case 'certificoActividad':
        return this.listaCertificoActividades.find((item: ListaValorRequestDto) =>
          item.codigo == this.formSupuestosAdmisibilidad.controls['certificoActividad']?.value);
      case 'codigoGrupoPreparadores':
        return this.listaCodigoGrupoPreparadores.find((item: ListaValorRequestDto) =>
          item.id == this.formInformacionFinancieraMes.controls['codigoGrupoPreparadores']?.value);
      default:
        return undefined;
    }
  }
}
